import * as yup from 'yup';
import { validateSchema } from "../utils/validationUtils";

const governmentSchema = yup.object().shape({
    tenCoSo: yup
        .string()
        .required("Tên cơ sở là bắt buộc")
        .test('trim', 'Tên cơ sở là bắt buộc', value => value && value.trim().length > 0)
        .max(230, "Tên cơ sở không được vượt quá 230 ký tự"),
    diaChi: yup
        .string()
        .required("Địa chỉ là bắt buộc")
        .test('trim', 'Địa chỉ là bắt buộc', value => value && value.trim().length > 0)
        .max(500, "Địa chỉ không được vượt quá 500 ký tự"),
    soDienThoai: yup
        .string()
        .required("Số điện thoại là bắt buộc")
        .test('trim', 'Số điện thoại là bắt buộc', value => Boolean(value && value.trim().length > 0))
        .test('vietnamese-phone', 'Số điện thoại không hợp lệ (gồm 10 số di động bắt đầu bằng 03, 05, 07, 08, 09 hoặc 10-11 số máy bàn bắt đầu bằng 02)', function (value) {
            if (!value) return false;
            const cleanPhone = value.replace(/[\s\-()]/g, '');
            return /^(03|05|07|08|09)\d{8}$|^02\d{8,9}$/.test(cleanPhone);
        }),
    moTa: yup
        .string()
        .nullable()
        .transform((value) => value === '' ? null : value),
    linkGoogleMap: yup
        .string()
        .required("Link Google Map là bắt buộc")
        .test('trim', 'Link Google Map là bắt buộc', value => value && value.trim().length > 0)
        .max(500, "Link Google Map không được vượt quá 500 ký tự. Vui lòng dùng link rút gọn từ nút Chia sẻ trên Google Maps.")
        .test('is-url', 'Link Google Map không hợp lệ', (value) => {
            if (!value) return false;
            try {
                new URL(value);
                return true;
            } catch {
                return false;
            }
        })
        .matches(
            /^(https?:\/\/)?(www\.)?(google\.com\/maps|goo\.gl\/maps|maps\.app\.goo\.gl)\/.+$/,
            "Link Google Map phải là URL của Google Maps"
        ),
});

export async function validateGovernmentForm(data) {
    const result = await validateSchema(governmentSchema, data);
    return { isValid: result.valid, errors: result.errors };
}